import React from 'react';
import PropTypes from 'prop-types';

// Inherits color via currentColor so callers can tint it; decorative.
function ClockIcon({ size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      style={{ verticalAlign: 'middle' }}
    >
      <circle cx="12" cy="12" r="9" />
      <polyline points="12 7 12 12 15 14" />
    </svg>
  );
}

ClockIcon.propTypes = {
  size: PropTypes.number,
};

ClockIcon.defaultProps = {
  size: 15,
};

export default ClockIcon;
